"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionElements = void 0;
/**
 * This wraps all camunda specific properties and elements that can be
 * associated with any BPMN element.
 * For example, for ServiceTasks, these will store the properties
 * 'module', 'method' and 'params'.
 */
class ExtensionElements {
    constructor() {
        this.camundaExtensionProperties = [];
    }
}
exports.ExtensionElements = ExtensionElements;
//# sourceMappingURL=ExtensionElements.js.map